import React from 'react';
import Title from 'lib/src/components/typography/Title';
import ChallengeAssessmentsTable from './AssessmentChallengesTable';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import { assessmentsBreadcrumb } from '@constants/breadcrumbItems';

const AssessmentChallenges: React.FC = () => {
    return (
        <>
            <Breadcrumb items={assessmentsBreadcrumb} />
            <Title>My Challenges to Assess</Title>
            <ChallengeAssessmentsTable />
        </>
    );
};

export default AssessmentChallenges;
